/* LUVORNE collection: mobile filter drawer, sort via URL, desktop auto-apply, sticky toolbar offset.
   The native GET filter form works without JS (server-rendered, filters via URL). */
(function () {
  function init(section) {
    var open = section.querySelector('[data-lv-open]');
    var close = section.querySelector('[data-lv-close]');
    var scrim = section.querySelector('[data-lv-scrim]');
    var panel = section.querySelector('[data-lv-facets]');
    var form = section.querySelector('[data-lv-filter-form]');
    var sort = section.querySelector('[data-lv-sort]');
    var toolbar = section.querySelector('.lv-toolbar');
    var mq = window.matchMedia('(max-width: 749px)');
    var timer, ticking = false;
    section.classList.add('lv-js');
    function isOpen() { return section.classList.contains('lv-filters-open'); }
    function sync() {
      if (panel) {
        if (mq.matches && !isOpen()) { panel.setAttribute('inert', ''); panel.setAttribute('aria-hidden', 'true'); }
        else { panel.removeAttribute('inert'); panel.removeAttribute('aria-hidden'); }
        if (mq.matches) { panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); panel.setAttribute('aria-label', 'Filtros'); }
        else { panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); panel.removeAttribute('aria-label'); }
      }
      if (open) open.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    }
    function offsetToolbar() {
      ticking = false;
      if (!toolbar) return;
      if (!mq.matches) { toolbar.style.top = ''; return; }
      var top = 0;
      document.querySelectorAll('header, .site-header, #SiteHeader, .header-wrapper, [data-header-sticky]').forEach(function (h) {
        var cs = window.getComputedStyle(h);
        if (cs.position === 'sticky' || cs.position === 'fixed') { var r = h.getBoundingClientRect(); if (r.bottom > top && r.top <= 1) top = r.bottom; }
      });
      toolbar.style.top = Math.max(0, Math.round(top)) + 'px';
    }
    function requestOffset() { if (!ticking) { ticking = true; window.requestAnimationFrame(offsetToolbar); } }
    window.addEventListener('scroll', requestOffset, { passive: true });
    window.addEventListener('resize', requestOffset);
    function setDrawer(show) {
      section.classList.toggle('lv-filters-open', show);
      document.documentElement.style.overflow = show ? 'hidden' : '';
      sync();
      if (show) { (close || panel).focus(); } else if (open) { open.focus(); }
    }
    if (open) open.addEventListener('click', function () { setDrawer(true); });
    if (close) close.addEventListener('click', function () { setDrawer(false); });
    if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape') { setDrawer(false); return; }
      if (e.key === 'Tab' && panel) {
        var items = panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,summary');
        if (!items.length) return;
        var first = items[0], last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    var onMq = function () { if (!mq.matches && isOpen()) setDrawer(false); else sync(); requestOffset(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else mq.addListener(onMq);
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
    if (form) form.addEventListener('change', function () {
      if (mq.matches) return;
      clearTimeout(timer);
      timer = setTimeout(function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }, 350);
    });
    if (form) form.addEventListener('submit', function () { document.documentElement.style.overflow = ''; });
    sync();
    offsetToolbar();
  }
  document.querySelectorAll('[data-lv-collection]').forEach(init);
})();
